import { VideoState } from '@/utils/constant';

export enum RoadTestTaskType {
  COMPREHENSIVE = 'COMPREHENSIVE',
  FATIGUE = 'FATIGUE',
}

export enum RoadTestResult {
  PASS = 'PASS',
  FAIL = 'FAIL',
}

/** 车辆归属方 ownerUseCase 枚举 */
export enum VehicleOwnerUseCase {
  SOLUTION = 'SOLUTION',
  OPEN = 'OPEN',
  PRODUCT = 'PRODUCT',
  SCHEDULE = 'SCHEDULE',
  RD = 'RD',
  TEST = 'TEST',
  HARDWARE = 'HARDWARE',
  FIX = 'FIX',
  OUTER = 'OUTER',
  OTHER = 'OTHER',
  BUSINESS_LEASING = 'BUSINESS_LEASING',
  JD_EDUCATION = 'JD_EDUCATION',
  INNOVATE = 'INNOVATE',
  STATIC_DISPLAY = 'STATIC_DISPLAY',
  JKC = 'JKC',
}

/** 通用接口响应结构 */
export interface ApiResponse<T = unknown> {
  code: string;
  data: T;
  message?: string;
}

export interface RoadTestScheme {
  schemeNo: string;
  schemeName: string;
  itemList?: RoadTestItem[];
  stopList?: RoadTestStop[];
}

export interface RoadTestItem {
  itemNo: string;
  itemName: string;
}

export interface RoadTestStop {
  stopId: number;
  stopName: string;
}

export interface RoadTestQuestion {
  questionNo: string;
  questionName: string;
  passOptName: string;
  failOptName: string;
  passed?: boolean | null;
}

export interface RoadTestDefect {
  defectNo: string;
  name: string;
  defectTime: string;
}

export interface RoadTestAccident {
  accidentNo: string;
  name: string;
  accidentTime: string;
  accidentUrl: string;
}

export interface RoadTestItemDetail extends RoadTestItem {
  questionList?: RoadTestQuestion[];
  type?: string;
  defectList?: RoadTestDefect[];
  accidentList?: RoadTestAccident[];
}

export interface RoadTestTaskDetail {
  taskNo: string;
  vehicleName?: string;
  taskType?: RoadTestTaskType;
  itemList?: RoadTestItemDetail[];
  type?: string;
  defectList?: RoadTestDefect[];
  accidentList?: RoadTestAccident[];
  overallResult?: RoadTestResult | null;
  /** 整体结果修改原因（保存/提交时写入，详情接口回传） */
  modifyReason?: string | null;
  currentRoadName?: string;
  currentRoadNo?: string;
  finished?: boolean;
}

export interface QuestionResultDTO {
  questionNo: string;
  result: boolean | null;
}

export interface ItemResultDTO {
  itemNo: string;
  questionList: QuestionResultDTO[];
}

export interface SaveRoadTestTaskParams {
  vehicleName: string;
  taskNo: string;
  overallResult?: RoadTestResult | null;
  changeResultReason?: string;
  itemResult: ItemResultDTO[];
}

export interface CreateRoadTestTaskParams {
  taskType: RoadTestTaskType;
  vehicleName: string;
  taskSchemeNo: string;
  fatigueLaps?: number;
}

export interface GetRoadTestSchemeListParams {
  taskType: RoadTestTaskType;
  vehicleName: string;
}

export interface CancelRoadTestTaskParams {
  vehicleName: string;
  taskNo: string;
  cancelReason: string;
}

export interface VehicleReplaySegment {
  stopNames: string;
  eventId: number;
  startTime: string;
  endTime: string;
}

export interface GetVehicleReplaySegmentsParams {
  taskNo: string;
}

export interface ShadowEventDetail {
  endTime: string;
  eventNo: string | null;
  id: number;
  jiraNo: string | null;
  realtimeId: number;
  reportTime: string;
  startTime: string;
  thirdDimensionTaskId: string;
  thirdDimensionTaskState: string;
  vehicleName: string;
  videoState: VideoState;
  videoTaskId: string;
}

export interface GetRoadTestTaskDetailParams {
  vehicleName: string;
  taskNo?: string;
}
